import React from "react";
import {
  ResourcesPostsBase,
  Headline,
  Posts,
  ButtonWrapper,
  ResourceButton,
} from "./resources-posts.styled";
import {
  ResourcesPostsSliceFragment,
  ContentPostFragment,
} from "../../types/graphql";
import SmallPostCard from "../small-post-card/small-post-card";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { linkTo } from "../../utils/contentUtils";

export type IResourcesPostsProps = Slice<
  SharedSliceType,
  ResourcesPostsSliceFragment["primary"],
  ResourcesPostsSliceFragment["items"][number]
> & { type: SharedSliceType };

const ResourcesPosts = ({
  slice,
  context,
}: SliceComponentProps<IResourcesPostsProps, IPageContext>) => {
  const posts = slice.items;
  let visiblePosts = posts;

  const buttonLink = slice.primary?.button_link;
  const buttonText = slice.primary?.button_text;

  // The following makes it so post will only show in rows of 4.
  // Any remainders will not render.
  if (posts && posts.length <= 4) {
    visiblePosts = posts.slice(0, 4);
  } else {
    const numToDelete = posts.length % 4;
    visiblePosts = posts.slice(0, posts.length - numToDelete);
  }

  return (
    (slice && (
      <ResourcesPostsBase className="slice-section">
        <div className="container">
          {slice.primary?.headline && (
            <Headline>{slice.primary.headline}</Headline>
          )}
          <Posts>
            {visiblePosts &&
              visiblePosts.map(
                (post, index) =>
                  post?.content_post?.document && (
                    <SmallPostCard
                      key={index}
                      post={post.content_post.document as ContentPostFragment}
                    />
                  )
              )}
          </Posts>
          {buttonLink && buttonText && (
            <ButtonWrapper>
              <ResourceButton to={linkTo(buttonLink)}>
                {buttonText}
              </ResourceButton>
            </ButtonWrapper>
          )}
        </div>
      </ResourcesPostsBase>
    )) || <></>
  );
};

export default ResourcesPosts;
